import React, { useEffect, useRef, useState } from 'react';

const Revele = ({ as: Tag = 'div', className = '', children, ...rest }) => {
  const ref = useRef(null);
  const [vu, setVu] = useState(false);

  useEffect(() => {
    const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduit || !('IntersectionObserver' in window)) {
      setVu(true);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entrees) => {
        entrees.forEach((e) => {
          if (e.isIntersecting) {
            setVu(true);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <Tag ref={ref} className={`rev${vu ? ' vu' : ''}${className ? ' ' + className : ''}`} {...rest}>
      {children}
    </Tag>
  );
};

export default Revele;
